<template>
  <div class="player" :class="{'playerDark':isDark}">
    <div class="dataCard" v-if="playerInfo">
      <headSssembly
          :showSearch="true" :showShare="isShowShare"
          :titleTransparent="playerInfo ? playerInfo.name_s : ''"
          :isDark="isDark"
          @share="share"
        />
      <div class="info">
        <div class="img">
          <img :src="playerInfo.logo" alt="">
        </div>
        <div class="detail">
          <div class="top">
            <div class="userInfo">
              <div class="name">
                <p>{{playerInfo.name_s}}</p>
                <p @click="goTeam(playerInfo.team_id)">{{playerInfo.team_name}} ></p>
              </div>
              <div class="desc">{{playerInfo.name_e}}</div>
            </div>
            <div class="follow" @click="getFollowPlayer(playerInfo, playerInfo.is_follow)">
              {{playerInfo.is_follow == 0 ? '关注' : '已关注'}}
            </div>
          </div>
          <div class="bottom">
            <p>身高{{playerInfo.tallness}}cm / 体重{{playerInfo.weight}}KG</p>
            <p>{{playerInfo.fans}}粉丝</p>
          </div>
        </div>
      </div>
      <div class="record">
        <div>
          <p><span>{{playerInfo.age}}</span>岁</p>
          <p>年龄</p>
        </div>
        <div>
          <p><span>{{playerInfo.birthday.substring(0, 10)}}</span></p>
          <p>出生日期</p>
        </div>
        <div>
          <p><span>{{playerInfo.number}}</span></p>
          <p>号码</p>
        </div>
        <div>
          <p><span>{{playerInfo.place}}</span></p>
          <p>场上位置</p>
        </div>
      </div>
    </div>
    <div class="tabs">
      <div :class="{'active' : tabs == 'material'}" @click="tabs='material'">资料</div>
      <!-- <div :class="{'active' : tabs == 'data'}" @click="tabs='data'">数据</div> -->
      <div :class="{'active' : tabs == 'career'}" @click="tabs='career'">生涯</div>
      <div :class="{'active' : tabs == 'dynamic'}" @click="tabs='dynamic'">动态</div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import headSssembly from "@/components/common/headSssembly"
import { getFollowPlayer } from "@/api/team.js"
import { doLogin } from "@/utils/base.js"
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: 'player',
    components: {
        headSssembly
    },
    data () {
        return {
            tabs: 'material',
            player_id: this.$route.query.player_id || 18
        }
    },
    computed: {
        playerInfo () {
            return this.$store.state.team.playerInfo
        },
        isDark () {
            return this.$store.state.common.isDark
        },
        isShowShare () {
            const src = this.$route.query.src
            if (src) {
                if (src.split('_')[2] === '106') {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        }
    },
    created () {
        jsbridg.hideAppBar(0)
        this.tabs = this.$route.name
        this.$store.dispatch('getPlayerBase', { player_id: this.player_id })
    },
    methods: {
        share () {
            var shareobj = {
                title: this.playerInfo ? this.playerInfo.name_s : '',
                desc: "查看球员最新动态、详细资料等",
                link: window.location.href,
                imgUrl: this.playerInfo.logo
            }
            jsbridg.appShare(shareobj);
        },
        goTeam (id) {
            jsbridg.goWebview({
                url: process.env.VUE_APP_DOMAIN + `/team/database?team_id=${id}&top_bar_style=2`,
                jumptype: 2
            });
        },
        async getFollowPlayer (item, status) {
            const params = {
                player_id: item.player_id,
                status: status * 1 === 0 ? 1 : 0
            }
            const res = await getFollowPlayer(params)
            if (res.errno * 1 === 0) {
                if (item.is_follow === 1) {
                    this.$toast("取消成功")
                    item.is_follow = 0
                } else {
                    this.$toast("关注成功")
                    item.is_follow = 1
                }
            } else if (res.errno * 1 === -1) {
                doLogin()
            } else {
                this.$toast(res.errmsg)
            }
        }
    },
    watch: {
        tabs (news) {
            this.$router.push({
                path: '/teamInfo/player/' + news,
                query: this.$route.query
            })
        }
    }
}
</script>

<style lang="less" scoped>
.player {
  min-height: 100vh;
  .dataCard {
      // height: 211px;
      background: #3755D1;
      overflow: hidden;
      .info {
        padding: 10px 12px;
        display: flex;
        .img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #ffffff;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .detail {
          padding-left: 12px;
          flex: 1;
          .top {
            display: flex;
            justify-content: space-between;
            .userInfo {
              .name {
                display: flex;
                align-items: center;
                p {
                  &:first-child {
                    font-size: 17px;
                    font-weight: 500;
                    color: #FFFFFF;
                  }
                  &:last-child {
                    height: 20px;
                    background: #2C44A7;
                    border-radius: 10px;
                    padding: 0 8px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 20px;
                    margin-left: 10px;
                  }
                }
              }
              .desc {
                font-size: 13px;
                font-weight: 400;
                color: #FFFFFF;
              }
            }
            .follow {
              height: 25px;
              border-radius: 15px;
              border: 1px solid #FFFFFF;
              padding: 0 10px;
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 25px;
            }
          }
          .bottom {
            margin-top: 3px;
            display: flex;
            justify-content: space-between;
            p {
              &:first-child {
                font-size: 13px;
                font-weight: 400;
                color: #9BAAE8;
              }
              &:last-child {
                font-size: 13px;
                font-weight: 400;
                color: #FFFFFF;
              }
            }
          }
        }
      }
      .record {
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        padding: 0 3px;
        padding-bottom: 15px;
        // padding: 0 20px;
        div {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          p {
            span {
              font-size: 15px;
              font-weight: bold;
              color: #FFFFFF;
            }
            &:first-child {
              font-size: 10px;
              font-weight: 400;
              color: #FFFFFF;
            }
            &:last-child {
              font-size: 10px;
              font-weight: 400;
              color: #9BAAE8;
            }
          }
        }
      }
  }
  .tabs {
    height: 35px;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px solid #EEEEEE;
    div {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 35px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
    }
    .active {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      position: relative;
      &::after{
          position: absolute;
          bottom: 0;
          content: '';
          width: 18px;
          height: 3px;
          background: #169AFF;
          border-radius: 1px;
      }
    }
  }
}
.playerDark{
    background-color: #191919;
    .dataCard{
        .info{
            .detail{
                .top{
                    .userInfo {
                        .name {
                            p {
                                &:first-child {
                                    // color: #191919;
                                }
                            }
                        }
                        .desc{
                            // color: #191919;
                        }
                    }
                }
                .follow{
                    border-color: #191919;
                    color: #191919;
                }
            }
            .bottom{
                p {
                    &:last-child {
                        // color: #191919;
                    }
                }
            }
        }
        .record{
            div {
                p {
                    &:first-child {
                        // color: #191919;
                    }
                }
            }
        }
    }
    .tabs {
        border-color: #2f2f2f;
        div{
            color: #d3d3d3;
        }
        .active {
            color: #d3d3d3
        }
    }
}
</style>
